export enum APPOINTMENT_NOTIFICATION_CREATED_BY {
  CUSTOMER = 'CUSTOMER',
  EMPLOYEE = 'EMPLOYEE',
}
